import Alpine from 'alpinejs';
import { animate, inView, stagger } from 'motion';
import { createIcons, icons } from 'lucide';

window.Alpine = Alpine;

export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('👋🏻 from common.ts');
    createIcons({ icons });
    Alpine.start();

    inView(
      '.fadeIn',
      (element) => {
        animate(
          element,
          { opacity: 1, y: [24, 0] },
          {
            duration: 0.5,
          },
        );
      },
      { margin: '0px 0px -200px' },
    );

    // Stagger animation for children of elements with class 'staggerChildren'
    inView(
      '.staggerChildren',
      (element) => {
        // Get all direct children
        const children = Array.from(element.children);

        // Animate all children with a staggered effect using the stagger function
        animate(
          children,
          { opacity: 1, y: [24, 0] },
          {
            duration: 0.5,
            delay: stagger(0.2),
          },
        );
      },
      { margin: '0px 0px -200px' },
    );

    // Stagger animation for children of elements with class 'staggerChildren'
    inView(
      '.staggerChildrenFast',
      (element) => {
        // Get all direct children
        const children = Array.from(element.children);

        // Animate all children with a staggered effect using the stagger function
        animate(
          children,
          { opacity: 1, y: [24, 0] },
          {
            duration: 0.5,
            delay: stagger(0.12),
          },
        );
      },
      { margin: '0px 0px -200px' },
    );
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
